import GridCard from '@Guidelines/Component/GridCard';
import { theme } from '@Guidelines/Theme/theme';
import FieldRow from '@UI/Pages/Administration/Organizations/OrganizationCard/FieldRow';
import OrganizationCardActions from '@UI/Pages/Administration/Organizations/OrganizationCard/OrganizationCardActions';
import type OrganizationView from '@UI/Store/Organizations/Views/OrganizationView';
import { css } from '@emotion/react';
import type * as React from 'react';

const ORGANIZATION_CARD_TRACK_COUNT = 5;

const nameStyle = css`
	${theme.typography.cardTitle}
	margin: 0;
	color: ${theme.colors.ink};
`;

type Props = {
	readonly organization: OrganizationView;
};

/**
 * One organization, laid out as a five-track subgrid cell: the four fields the API returns — raison
 * sociale, SIRET, siège social, document footer mentions — plus actions. Rendered identically whether
 * the account holds one organization or several: there is no single-organization variant.
 */
const OrganizationCard: React.FC<Props> = ({ organization }) => {
	return (
		<GridCard trackCount={ORGANIZATION_CARD_TRACK_COUNT} rowGap="0.875rem">
			<h2 css={nameStyle}>{organization.name}</h2>
			<FieldRow label="SIRET" value={organization.siret} />
			<FieldRow label="Adresse du siège" value={organization.headOfficeAddress} />
			<FieldRow label="Mentions de pied de document" value={organization.documentFooterMentions} />
			<OrganizationCardActions organization={organization} />
		</GridCard>
	);
};

export default OrganizationCard;
